import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { LoadingButton } from '@mui/lab';

const OpenDialogBox = ({ open, onClose, onDelete, isLoading = false }) => {
  const handleDelete = async () => {
    await onDelete();
    onClose();
  };
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="delete-dialog-title">
      <DialogTitle id="delete-dialog-title">Are you sure you want to delete this?</DialogTitle>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>Cancel</Button>
        <LoadingButton type="button" onClick={handleDelete} loading={isLoading}>
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

OpenDialogBox.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default OpenDialogBox;
